import React, { useState, useEffect, useRef } from "react";
import SpecialtyDropdown from "../shared/SpecialtyDropdown";
import useUserStore from "../../utils/storeApp";
import CallAPI from "../../services/apiCalls";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { stateCodeArray } from "../../services/fakeDB/ListUser";

const mdl = {
  UserId: null,
  OrganizationId: null,
  OrganizationKind: "",
  DirectorySource: "All",
  DirectoryType: "Providers",
  SearchByName: null,
  FirstName: null,
  LastName: null,
  OrganizationName: null,
  NationalProviderID: null,
  ContactEmail: null,
  DirectEmail: null,
  Address: null,
  City: null,
  Zip: null,
  SpecialitySpecialization: null,
  DomainName: null,
  SERV_DESC: "",
  Resultsize: 0,
};
const AdvSearch = () => {
  const navigate = useNavigate();
  const { SetSharedObject, userRole, userToken, sharedObject } = useUserStore(
    (state) => ({
      SetSharedObject: state.SetSharedObject,
      userRole: state.userRole,
      userToken: state.userToken,
      sharedObject: state.sharedObject,
    }),
  );
  const [errDetailFlag, SetErrDetailFlag] = useState(false);
  const [errDetailMsg, SetErrDetailsMsg] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [answers, setAnswers] = useState(mdl);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("advDirSearchModal");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const setAnswer = async (questionId, answer) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const AdvSearchFunc = async () => {
    await SetSharedObject("DirectoryType", answers.DirectoryType);
    let obj = answers;
    if (answers.DirectoryType === "Organizations") {
      obj = {
        ...answers,
        FullName: null,
        OrganizationName: answers.FullName,
      };
    }
    setProcessing(true);
    let call = "/directorySearch/Search";
    const res = await CallAPI(call, obj, "post", userToken);
    await SetSharedObject("ResponseCode", res.code);
    setProcessing(false);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data.pageItems) {
        el.DirectoryType = answers.DirectoryType;
        temp.push(el);
      }
      await SetSharedObject("AdvSearchObj", temp);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "<div>";
      for (let el of msg) {
        str += `${el}`;
      }
      str += "</div>";
      SetErrDetailsMsg(str);
      SetErrDetailFlag(true);
    }
    setProcessing(false);
  };
  const SpecialFormFields = async (val) => {
    await setAnswers({
      ...answers,
      SpecialityType: val?.SpecialityType,
      SpecialityCLassification: val?.Classification,
      SpecialitySpecialization: val?.Specialization,
    });
  };
  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
    if (sharedObject.DirectoryType)
      setAnswer("DirectoryType", sharedObject.DirectoryType);
    let timer;
    if (processing) {
      timer = setTimeout(() => {
        setLoadingText("Working on it...");
      }, 10000);
    } else {
      setLoadingText("Loading...");
    }

    return () => clearTimeout(timer);
  }, [processing, sharedObject.DirectoryType]);

  const CloseModal = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    $("#advDirSearchModal").modal("hide");
  };

  return (
    <div className="AdvSearch">
      <div
        className="modal fade"
        id="advDirSearchModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="advDirSearchModalTitle"
        aria-describedby="advDirSearchModalDesc"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-slideout">
          <div className="modal-content">
            <div className="modal-header">
              <h2
                className="modal-title spacer-inline"
                id="advDirSearchModalTitle"
              >
                Search
              </h2>
              <button
                type="button"
                className="close"
                aria-label="Close Close directory search"
                onClick={CloseModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <form aria-label="Directory advanced search form">
              <div className="modal-body">
                <p id="advDirSearchModalDesc" className="sr-only">
                  Search the directory by name, NPI, location, email, or
                  specialty.
                </p>
                <div className="modal-content-body container">
                  {/*NPI*/}
                  <div className="field-wrapper spacer-inline w-md2 spacer-margin1">
                    <label htmlFor="advSearch-npi">NPI</label>
                    <input
                      type="text"
                      className="form-control"
                      id="advSearch-npi"
                      autoComplete="off"
                      ref={firstFocusRef}
                      value={answers.NationalProviderID}
                      onChange={(el) => {
                        setAnswer("NationalProviderID", el.target.value);
                      }}
                    />
                  </div>
                  {/*Name*/}
                  {answers.DirectoryType === "Organizations" ? (
                    <div className="field-wrapper">
                      <label htmlFor="advSearch-FullName">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="advSearch-FullName"
                        autoComplete="off"
                        value={answers.FullName}
                        onChange={(el) => {
                          setAnswer("FullName", el.target.value);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="field-wrapper">
                      <div className="field-wrapper sp-mx6 spacer-inline w-md2 v-top">
                        <label htmlFor={"advSearch-FirstName"}>
                          First Name
                        </label>
                        <input
                          id={"advSearch-FirstName"}
                          type="text"
                          className="form-control"
                          autoComplete="given-name"
                          onChange={(el) => {
                            setAnswer("FirstName", el.target.value);
                          }}
                          value={answers?.FirstName || ""}
                        />
                      </div>
                      <div className="field-wrapper spacer-inline w-md2 v-top">
                        <label htmlFor={"advSearch-LastName"}>Last Name</label>
                        <input
                          id={"advSearch-LastName"}
                          type="text"
                          className="form-control"
                          autoComplete="family-name"
                          onChange={(el) => {
                            setAnswer("LastName", el.target.value);
                          }}
                          value={answers?.LastName || ""}
                        />
                      </div>
                    </div>
                  )}
                  {/*Directories to Search Begnins */}
                  <div className="field-wrapper">
                    <div className="spacer-inline w-md2 sp-mx6 v-top">
                      <label htmlFor="advSearch-DirectorySource">
                        Directory to Search
                      </label>
                      <select
                        className="form-control"
                        id="advSearch-DirectorySource"
                        name="DirectorySource"
                        value={answers.DirectorySource}
                        onChange={(el) => {
                          setAnswer("DirectorySource", el.target.value);
                        }}
                      >
                        <option value="All">All</option>
                        <option value="SES">Local</option>
                      </select>
                    </div>
                    <div className="spacer-inline w-md2 v-top">
                      <label htmlFor="advSearch-DirectoryType">
                        Directory Type
                      </label>
                      <select
                        className="form-control"
                        id="advSearch-DirectoryType"
                        name="DirectoryType"
                        value={answers.DirectoryType}
                        onChange={(el) => {
                          setAnswer("DirectoryType", el.target.value);
                        }}
                      >
                        <option value="Providers">Provider</option>
                        <option value="Organizations">Organization</option>
                      </select>
                    </div>
                  </div>

                  {answers.DirectoryType === "Organizations" ? (
                    <div className="field-wrapper">
                      <label htmlFor="advSearch-OrganizationKind">
                        Organization Type
                      </label>
                      <select
                        className="form-control"
                        id="advSearch-OrganizationKind"
                        name="OrganizationKind"
                        value={answers.OrganizationKind}
                        onChange={(el) => {
                          setAnswer("OrganizationKind", el.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {sharedObject?.getOrgKinds?.map((el) => (
                          <option key={el.id} value={el.name}>
                            {el.description}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : null}

                  {/*Service Description*/}
                  <div className="field-wrapper spacer-inline w-full">
                    <label htmlFor="advSearch-ServiceDescription">
                      Service Description
                    </label>
                    <select
                      className="form-control w-full"
                      id="advSearch-ServiceDescription"
                      value={answers.SERV_DESC}
                      onChange={(el) => {
                        setAnswer("SERV_DESC", el.target.value);
                      }}
                    >
                      <option value="">Select</option>
                      {sharedObject?.getServDesc?.map((el) => (
                        <option key={el.code} value={el.code}>
                          {el.display}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/*Email*/}
                  <div className="field-wrapper">
                    <label htmlFor="advSearch-DirectEmail">Direct Email</label>
                    <input
                      type="text"
                      className="form-control"
                      id="advSearch-DirectEmail"
                      autoComplete="off"
                      value={answers.DirectEmail}
                      onChange={(el) => {
                        setAnswer("DirectEmail", el.target.value);
                      }}
                    />
                  </div>
                  {/*City*/}
                  <div className="field-wrapper">
                    <label htmlFor="advSearch-City">City</label>
                    <input
                      type="text"
                      className="form-control"
                      id="advSearch-City"
                      autoComplete="address-level2"
                      value={answers.City}
                      onChange={(el) => {
                        setAnswer("City", el.target.value);
                      }}
                    />
                  </div>
                  {/* State and Zip*/}
                  <div className="field-wrapper ">
                    <div className="field-box2 field-ext sp-mx6">
                      <label htmlFor="advSearch-State">State</label>
                      <select
                        className="form-control"
                        id="advSearch-State"
                        name="State"
                        value={answers.State}
                        onChange={(el) => {
                          setAnswer("State", el.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {stateCodeArray.map((el) => (
                          <option key={el} value={el}>
                            {el}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="field-box1 field-ext">
                      <label htmlFor="advSearch-Zip">Zip</label>
                      <input
                        className="form-control"
                        id="advSearch-Zip"
                        name="Zip"
                        autoComplete="postal-code"
                        value={answers.Zip}
                        onChange={(el) => {
                          setAnswer("Zip", el.target.value);
                        }}
                      />
                    </div>
                  </div>

                  <div className=" field-wrapper">
                    <div id="accordion" className="accordion">
                      <div className="card mb-0">
                        <button
                          type="button"
                          className="btn btn-link card-header collapsed"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                          aria-label="Expand specialty search options"
                        ></button>
                        <div
                          id="collapseThree"
                          className="collapse"
                          data-parent="#accordion"
                        >
                          <div className="field-wrapper spacer-margin4">
                            <h3 className="ctr sub-titles spacer-margin7 blk-clr">
                              Specialty
                            </h3>
                            <div className="text-reg spacer-margin7">
                              All three criteria must be selected to search by
                              Specialty.
                            </div>
                            <SpecialtyDropdown
                              SpecialFormFields={(el, val) =>
                                SpecialFormFields(el, val)
                              }
                            />

                            {/*Specialty Component */}
                            {/*<SpecialtyDropdown />*/}
                            <p className="text-reg">
                              Not all search criteria fields may be available
                              for each directory information source.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {errDetailFlag && (
                    <div
                      className="alert alert-danger"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      dangerouslySetInnerHTML={{ __html: errDetailMsg }}
                    />
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-success"
                  aria-busy={processing}
                  disabled={processing}
                  onClick={(el) => AdvSearchFunc()}
                >
                  {processing ? "Searching..." : "Search"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={CloseModal}
                >
                  Cancel
                </button>
              </div>
              {processing && (
                <div
                  className="loader-container"
                  role="status"
                  aria-live="polite"
                  aria-atomic="true"
                  aria-labelledby="adv-directorysearch-loader"
                >
                  <div className="spinner" aria-hidden="true"></div>
                  <div className="loading-text" id="adv-directorysearch-loader">
                    {loadingText}
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvSearch;
